module.exports = function(app) {
	app.filter('productName', ['coverageBuddy', function(coverageBuddy) {
		return function(lob) {

			lob = lob instanceof Object
				? lob.lineOfBusiness.toUpperCase()
				: lob.toUpperCase();

			switch (lob) {
				case 'FA': return 'Facility';
				case 'PR': return 'Professional';
				case 'MM': return 'Major Medical';
				default: return getDefault(lob, coverageBuddy.coverageTypeMap);
			}

			function getDefault(lob, coverageTypeMap) {
				function isDental(lob) {
					return coverageTypeMap.dental.indexOf(lob) > -1;
				}
				function isDrug(lob) {
					return coverageTypeMap.drug.indexOf(lob) > -1;
				}
				function isMedical(lob) {
					return coverageTypeMap.medical.indexOf(lob) > -1;
				}
				function isService(lob) {
					return coverageTypeMap.service.indexOf(lob) > -1;
				}
				function isVision(lob) {
					return coverageTypeMap.vision.indexOf(lob) > -1;
				}

				if (isDental(lob)) { return 'Dental'; }
				if (isDrug(lob)) { return 'Drug'; }
				if (isMedical(lob)) { return 'Medical'; }
				if (isService(lob)) { return 'Service'; }
				if (isVision(lob)) { return 'Vision'; }
			}
		};
	}]);
};
